<template>
  <tr class="week">

    <td v-if="weeklyView">
      <div class="time-labels">
        <table class="time-labels-table">
          <tr v-for="i in 48" :key="'time-label-'+i" :id="'time-label-'+(i/2)">
            <td v-if="i % 2 == 1 && i / 2 > 1">
              <p>{{ convertToTimeLabel(i / 2 - 0.5) }}</p>
            </td>
            <td v-else><br></td>
          </tr>
        </table>
      </div>
    </td>

    <Day v-for="i in 7" :key="'day-'+i"
         :info="info"
         :date="displayWeek[i-1].date"
         :displayYear="displayWeek[i-1].year"
         :displayMonth="displayWeek[i-1].month"
         :todaysDate="todaysDate"
         :greyedOut="displayWeek[i-1].greyedOut"
         :weeklyView="weeklyView"/>
  </tr>
</template>

<script>
import Day from '../components/Day.vue'

export default {
  name: 'Week',
  components: {
    Day,
  },
  props: {
    info: { type: Array, required: true },
    displayWeek: Array, // 1d array with days visible in this week
    displayYear: Number,
    displayMonth: Number,
    todaysDate: String,
    weeklyView: Boolean
  },
  methods: {
    convertToTimeLabel(givenIndex) {
      if (givenIndex === 12) {
        return "12 PM";
      } else if (givenIndex < 12) {
        return givenIndex + " AM";
      }
      return (givenIndex - 12) + " PM";
    },
    scrollToHour(hour) {
      let calendarBody = document.getElementById("table-scrollable");
      let label = document.getElementById("time-label-"+hour);
      calendarBody.scrollTop = label.offsetTop;
    }
  },
  mounted() {
    if (this.weeklyView) {
      this.scrollToHour(8.5); // scroll to 8 am
    }
  },
  watch: {
    weeklyView: function() {
      this.$nextTick(function () {
        if (this.weeklyView) {
          this.scrollToHour(8.5); // scroll to 8 am
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.week {
  width: 100%;
}

.time-labels-table {
  border-collapse: collapse;
}
.time-labels-table tr {
  height: 28px;
  vertical-align: top;
}
.time-labels p {
  margin: -10px 0px;
  font-size: 13px;
  color: grey;
}
</style>
